import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../Component/Layout";
import Image1 from "../assets/Image/blank.svg";
import Image2 from "../assets/Image/walking-golf-ball-carrying-club-260nw-2573284593 1 (1).svg";
import GolfImage from "../assets/Image/1.png";
import { BiMap } from "react-icons/bi";
import { NavLink } from "react-router-dom";
import REACT_APP_API_URL from "../utils/constant";
import { usePlanContext } from "../context/plansContext";
import { useNavigate } from "react-router-dom";
import { useSavedEvents } from "../context/SavedEventContext";

const UserDetails = () => {
  const { id } = useParams();
  const {
    plans,
    selectedPlan,
    setSelectedPlan,
    fetchUserPlans,
    loading: plansLoading,
  } = usePlanContext();

  const {
    savedEvents,
    loading: eventLoading,
    fetchSavedEvents,
  } = useSavedEvents();

  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState({
    user: true,
    events: false,
  });
  const [activeTab, setActiveTab] = useState("plans");

  useEffect(() => {
    if (id) {
      fetchUserDetails(id);
      fetchUserPlans(id);
    }
  }, [id]);

  // Fetch saved events only when the tab is activated
  useEffect(() => {
    if (activeTab === "events" && savedEvents.length === 0) {
      fetchSavedEvents(id);
    }
  }, [activeTab, id]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const fetchUserDetails = async (userId) => {
    try {
      setLoading((prev) => ({ ...prev, user: true }));
      const response = await fetch(
        `${REACT_APP_API_URL}get-userdetails?id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      const result = await response.json();
      if (result.data) {
        setUserDetails(result.data);
      }
    } catch (e) {
      console.error("Error fetching user details:", e);
    } finally {
      setLoading((prev) => ({ ...prev, user: false }));
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Layout>
      <Link to="/users" className="btn btn-primary mb-4">
        Back
      </Link>

      <div className="row mb-12 gap-3">
        <div className="col-12">
          <div className="card">
            <div className="card-body p-5 text-center">
              {loading.user ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : userDetails ? (
                <>
                  <div className="position-relative mb-4 text-center">
                    <img
                      className="rounded-pill"
                      src={userDetails.image || Image1}
                      alt="User Profile"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <h5 className="card-title mb-0">{userDetails.full_name}</h5>
                  <p className="card-text mb-1">{userDetails.email}</p>
                  {userDetails.bio && <p className="mb-0">{userDetails.bio}</p>}
                </>
              ) : (
                <p>No user data found</p>
              )}
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <ul
                className="nav nav-pills mb-3 gap-2"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "plans" ? "active" : ""
                    }`}
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected={activeTab === "plans"}
                    onClick={() => handleTabChange("plans")}
                  >
                    Plans{" "}
                    {plansLoading && (
                      <span className="spinner-border spinner-border-sm ms-2"></span>
                    )}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${
                      activeTab === "events" ? "active" : ""
                    }`}
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected={activeTab === "events"}
                    onClick={() => handleTabChange("events")}
                  >
                    Saved Events{" "}
                    {loading.events && (
                      <span className="spinner-border spinner-border-sm ms-2"></span>
                    )}
                  </button>
                </li>
              </ul>

              <div className="tab-content p-0" id="pills-tabContent">
                {/* Plans Tab */}
                <div
                  className={`tab-pane fade ${
                    activeTab === "plans" ? "show active" : ""
                  }`}
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                  tabIndex="0"
                >
                  {plansLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : plans.length > 0 ? (
                    <div className="row">
                      {plans.map((plan, index) => (
                        <div
                          className="col-sm-6 col-12 col-md-4 col-xl-4 col-xxl-3 mb-5"
                          key={index}
                        >
                          <div className="card h-100">
                            <div className="position-relative">
                              <button
                                onClick={() => {
                                  setSelectedPlan(plan);
                                  navigate(
                                    `/users/detail/${userDetails.id}/plans/${plan.id}`
                                  );
                                }}
                                style={{
                                  border: "none",
                                  padding: 0,
                                  background: "none",
                                  width: "100%",
                                }}
                              >
                                <img
                                  className="card-img-top"
                                  src={plan.thumbnail}
                                  alt={plan.trip_name || "Plan"}
                                  style={{
                                    height: "180px",
                                    objectFit: "cover",
                                    width: "100%",
                                  }}
                                />
                              </button>
                            </div>
                            <div className="card-body p-3">
                              <h5 className="card-title">
                                {plan.trip_name || "Untitled Plan"}
                              </h5>
                              <p className="card-text para mb-2 text-muted small">
                                {plan.stay}
                              </p>
                              {plan.description && (
                                <p className="card-text para mb-2">
                                  {plan.description.length > 100
                                    ? `${plan.description.substring(0, 100)}...`
                                    : plan.description}
                                </p>
                              )}
                              <div className="d-flex justify-content-between align-items-center">
                                <small className="text-muted">
                                  {plan.clubs?.length || 0} Clubs
                                </small>
                                <small className="text-muted">
                                  {plan.stays?.length || 0} Stays
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <img
                        src={Image2}
                        alt="No plans"
                        style={{ width: "100px", opacity: 0.8 }}
                      />
                      <p className="mt-3 text-muted">No plans found</p>
                    </div>
                  )}
                </div>

                {/* Saved Events Tab */}
                <div
                  className={`tab-pane fade ${
                    activeTab === "events" ? "show active" : ""
                  }`}
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                  tabIndex="0"
                >
                  {eventLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : savedEvents.length > 0 ? (
                    <div className="row">
                      {userDetails &&
                        savedEvents.map((event, index) => (
                          <div
                            className="col-sm-6 col-12 col-md-4 col-xl-4 col-xxl-3 mb-5"
                            key={index}
                          >
                            <div className="card h-100">
                              <div className="position-relative">
                                <NavLink
                                  to={`/users/detail/${userDetails.id}/events/${event.id}`}
                                >
                                  <img
                                    className="card-img-top"
                                    src={event.thumbnail || GolfImage}
                                    alt={event.description || "Event"}
                                    style={{
                                      height: "180px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </NavLink>
                              </div>
                              <div className="card-body p-3">
                                <h5 className="card-title">
                                  {event.trip_name || "Untitled Event"}
                                </h5>
                                {event.date && (
                                  <p className="card-text text-muted small mb-2">
                                    {formatDate(event.date)}
                                  </p>
                                )}
                                {event.location && (
                                  <p className="card-text">
                                    <BiMap className="me-1" />
                                    {event.location}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <img
                        src={Image2}
                        alt="No events"
                        style={{ width: "100px", opacity: 0.8 }}
                      />
                      <p className="mt-3 text-muted">No saved events found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserDetails;
